import { render, staticRenderFns } from "./ProfitStatistics.vue?vue&type=template&id=dcc1b906&scoped=true&"
import script from "./ProfitStatistics.vue?vue&type=script&lang=js&"
export * from "./ProfitStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ProfitStatistics.vue?vue&type=style&index=0&id=dcc1b906&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc1b906",
  null
  
)

export default component.exports